import $ from 'jquery';
import nophotothumb from '../assets/no_photo_thumb.png';

export function getPhotos(photoObject = []) {
    const nophoto = nophotothumb;

    if (!Array.isArray(photoObject) || photoObject.length === 0) {
        $("#framePhoto").html('<img src="' + nophoto + '">');
        return;
    }

    const thumburl = photoObject[2];
    const largeurl = photoObject[0];

    if (!thumburl) {
        $("#framePhoto").html('<img src="' + nophoto + '">');
        return;
    }

    $.get(thumburl)
        .done(function () {
            $("#framePhoto").html(
                "<a href=" + largeurl + " target=" + _blank + ">" + "<img src=" + thumburl + ">" + '<br>'
            );
        })
        .fail(function () {
            $("#framePhoto").html('<img src="' + nophoto + '">');
        });
}

if (typeof window !== 'undefined') {
    window.getPhotos = getPhotos;
}
